import type { UserRole } from '@/constants/roleConstants'
import { ROLES } from '@/constants/roleConstants'
import { ROUTES } from '@/constants/routeConstants'

export const ROUTE_ACCESS: Partial<Record<string, Array<UserRole>>> = {
  [ROUTES.CONSULTANTS_LIST]: [
    ROLES.ADMIN,
    ROLES.COMMERCIAL,
    ROLES.CLIENT,
    ROLES.CANDIDAT,
  ],
  [ROUTES.CONSULTANT_DETAIL]: [
    ROLES.ADMIN,
    ROLES.COMMERCIAL,
    ROLES.CLIENT,
    ROLES.CANDIDAT,
  ],
  [ROUTES.BACKOFFICE]: [ROLES.ADMIN, ROLES.COMMERCIAL],
  [ROUTES.ADMIN]: [ROLES.ADMIN],
}
